export default "__VITE_ASSET__CiUEaT0f__"